/**
 * AuthStatusBar — la barre d'état d'un écran d'avant connexion : contenu foncé, sur le fond de page.
 *
 * Le legacy (`FamilyAccountSelectionScreen`) pose `<StatusBar style="dark" … translucent={false}>`.
 * Sur le design system, le fond est celui que peint `<AuthTemplate>` (`surface`) : c'est lui qui passe
 * derrière les icônes sur Android (`common/systemBars`), iOS et le web l'ignorent. Pas de sombre avant
 * la connexion : le contenu reste foncé.
 *
 * Le seul accès à `common/` de l'écran, par la même porte que `ParentStatusBar` : toute barre d'état
 * de l'app vient de `common/systemBars/StatusBar` (un test la garde), qui n'a pas d'équivalent dans
 * `data/`.
 */
import { useUnistyles } from "react-native-unistyles"

import { StatusBar } from "../../../../../common/systemBars/StatusBar"

export function AuthStatusBar() {
    const { theme } = useUnistyles()
    return <StatusBar style="dark" backgroundColor={theme.colors.surface} translucent={false} />
}
